'use strict';

/**
 * @private
 * @function
 * @description Binds the events for Beauty Consultation form
 */

import page from '../../page';
import modal from '../../modal';
import toggler from '../../toggler';
import progress from '../../progress';
import productTile from '../../product-tile';
import beautyConsultationHelpers from './beauty-consultation-helpers.js';

let consultationDrawer = null;
let consultationErrorPopup = null;

const beautyConsultation = {
    init: function () {
        if ($('.js-beauty-consultation-container').length === 0) {
            return;
        }

        if (SitePreferences.IS_CONSULTATION_DRAWER_ENABLED) {
            consultationDrawer = toggler.create('.drawer', '.drawer-content');
        }

        consultationErrorPopup = modal.create('#consultation-error-popup', '.modal-body', {});
        consultationErrorPopup.addCustomClass('small no-border');

        this.bindEvents();
    },
    bindEvents: function() {
        $('.js-beauty-consultation-form').on('change', function () {
            const formData = beautyConsultationHelpers.prepareFormData($(this));

            $.ajax({
                url: this.action,
                method: 'POST',
                data: formData,
                beforeSend: function () {
                    // prevent another click until ajax finishes
                    progress.show($('.js-beauty-consultation-form'));
                }
            }).done(function (data, textStatus, jqXHR) {
                // check if ajax returns json response
                if (jqXHR.responseJSON) {
                    if (jqXHR.responseJSON.error === 'CSRF Token Mismatch') {
                        page.redirect(Urls.csrffailed);
                    }
                } else {
                    // otherwise it had returned html
                    const resultHtml = $(data);
                    const errorElement = resultHtml.filter('.js-consultation-update-error');

                    if (errorElement.length > 0) {
                        const errorMessage = errorElement.data('error');
                        consultationErrorPopup.$cntr.find('.modal-description').empty().text(errorMessage);
                        consultationErrorPopup.open();
                    }

                    if (SitePreferences.IS_CONSULTATION_DRAWER_ENABLED) {
                        consultationDrawer.renderContent(resultHtml, productTile.initializeEvents);
                    }
                }
                progress.hide();
            }).fail(function (jqXHR) {
                page.redirectOnAjaxError(jqXHR);
            });
        });
    }
};

export default beautyConsultation;
